import { useState, useCallback, useEffect } from 'react';
const GLOBAL_STORE_CHANGE_EVENT = '__GLOBAL_STORE_CHANGE_EVENT__';

const dispatchEvent = (key, value) => {
  window.dispatchEvent(new CustomEvent(GLOBAL_STORE_CHANGE_EVENT, {
    detail: {
      key,
      value
    }
  }));
};

const useGlobalState = (key, initialState) => {
  const [value, setValue] = useState(initialState);
  const updateValue = useCallback(newValue => {
    if (typeof newValue === 'function') {
      setValue(prev => {
        const computedNewValue = newValue(prev);
        dispatchEvent(key, computedNewValue);
        return computedNewValue;
      });
      return;
    }

    dispatchEvent(key, newValue);
  }, [key]);
  useEffect(() => {
    const onValueChange = e => {
      if (e.detail.key === key) {
        var _e$detail;

        setValue(e == null ? void 0 : (_e$detail = e.detail) == null ? void 0 : _e$detail.value);
      }
    };

    window.addEventListener(GLOBAL_STORE_CHANGE_EVENT, onValueChange);
    return () => {
      window.removeEventListener(GLOBAL_STORE_CHANGE_EVENT, onValueChange);
    };
  }, [key]);
  const result = [value, updateValue]; // eslint-disable-next-line prettier/prettier

  return result;
};

const createGlobalStore = (key, initialState) => () => useGlobalState(key, initialState);

export { useGlobalState, createGlobalStore };